import React from 'react';
import { Heading } from '@chakra-ui/react';

export default function Logo() {
  return (
    <Heading as="h1" className="logo" userSelect="none">Crosswordye</Heading>
  );
}
